import * as React from 'react';

import { Box, Toolbar, Typography } from '@mui/material';

import { AppBar } from 'react-admin';
import {themeStyles} from "../index";

const MyAppBar = props => {
    const themeStyle = themeStyles();
    return (
        <Box sx={{flexGrow: 1, marginTop: '-48px', marginBottom: '12px', maxHeight: '60px'}}>
            <AppBar position="static"
                    sx={{ /* primary_bg */
                        backgroundColor: '#1e448f',
                        background: 'linear-gradient(145deg, #2E68DB 11%, #132B5C 75%)'
                        }}
                    {...props}>
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                        RMG <span className={themeStyle.bo_nav_header}>back<b>office</b></span>
                    </Typography>
                </Toolbar>
                <span className={themeStyle.spacer} />
            </AppBar>
        </Box>
    );
}

export default MyAppBar;